import type { TOC } from '@ember/component/template-only';
import PageError from '../components/page-error.gts';

interface Signature {
  Args: {};
}

const MySourcesError: TOC<Signature> = <template>
  <PageError @title="Failed to load my sources" @backRoute="index" />
</template>;

export default MySourcesError;
